import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";
import { useQlik } from "../../context/Qlik";
import NativeObject from "../../components/NativeObject/NativeObject";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import KpiCard from "../../components/KPI/KpiCard";
import utils from "../../QlikUtils";
import { forEach } from "lodash";

function MatrizDesktop({ app, config }) {
  const { container } = config.matriz;
  const [dataTable, setDataTable] = useState([]);

  const initializeField = async () => {
    await utils.createHyperCubeByQlikIdToTable(
      app,
      // "13208c27-bf55-4b3e-a94f-bdbafc963025",
      "UPbJhuH",
      35,
      (res) => {
        console.log("create Cube Tabe -> ", res);
        console.log("Extract Tabl e -> ", utils.extractDataSet(res));
        setDataTable(utils.extractDataSet(res));
      }
    );
  };

  useEffect(() => {
    if (app) {
      initializeField();
    }
  }, [app]);

  return (
    <div className="app matriz">
      <div className="appContent">
        <LayoutCardsWrapper>
          <CardWrapper customStyle={{ height: "20%" }}>
            {container[0].cards.map((card, index) => {
              return (
                <KpiCard
                  key={index}
                  app={app}
                  KPITitle={{
                    id: card.title.id,
                    hardTitle: card.title.hardTitle,
                  }}
                  iconId={card.nativeObject.iconId}
                  percentageId={card.nativeObject.percentageId}
                  greyValueId={card.nativeObject.greyValueId}
                  valueId={card.nativeObject.valueId}
                  customStyle={{ }}
                  isMobile={false}
                  colorIdentfy={card.nativeObject.colorIdentfy}
                ></KpiCard>
              );
            })}
          </CardWrapper>

          <CardWrapper customStyle={{ height: "80%",  paddingBottom: "40px" }}>
            <Card
              header={{
                hardTitle: container[1].cards[0].title.hardTitle,
                hardSubtitle: container[1].cards[0].subtitle.hard,
                tooltip: container[1].cards[0].title.tooltip,
              }}
              style={{ width: "65%", height: "100%" }}
            >
              {dataTable.length > 0 ? (
                <div style={{ marginTop: "8px" }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "2fr 6fr",
                    }}
                  >
                    <div></div>
                    <div
                      style={{
                        display: "flex",
                        height: "20px",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#ccc",
                        color: "#142948",
                        fontWeight: "600",
                      }}
                    >
                      NIVEA
                    </div>
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: " repeat(8, 1fr)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            height: "40px",
                          }}
                        ></div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "20px 20px 20px 1fr",
                          }}
                        >
                          {/* MERCADO */}
                          <div
                            style={{
                              display: "grid",
                              gridTemplateRows: "1fr 5fr",
                            }}
                          >
                            <div style={{ height: "60px" }}></div>
                            <div
                              style={{
                                width: "20px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "#ccc",
                                color: "#142948",
                                fontWeight: "600",
                              }}
                            >
                              <span>M</span>
                              <span>E</span>
                              <span>R</span>
                              <span>C</span>
                              <span>A</span>
                              <span>D</span>
                              <span>O</span>
                            </div>
                          </div>
                          {/* DN QUALIFICA */}
                          <div
                            style={{
                              display: "grid",
                              gridTemplateRows: "1fr 4fr 1fr",
                            }}
                          >
                            <div style={{ height: "60px" }}></div>
                            <div
                              style={{
                                width: "20px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "start",
                                alignItems: "center",
                                background: "#1E94AE",
                                color: "white",
                              }}
                            >
                              <span>D</span>
                              <span>N</span>
                              <br />
                              <span>Q</span>
                              <span>U</span>
                              <span>A</span>
                              <span>L</span>
                              <span>I</span>
                              <span>F</span>
                              <span>I</span>
                              <span>C</span>
                              <span>A</span>
                            </div>
                          </div>
                          {/* DN TOP */}
                          <div
                            style={{
                              display: "grid",
                              gridTemplateRows: "1fr 3fr 2fr",
                            }}
                          >
                            <div style={{ height: "60px" }}></div>
                            <div
                              style={{
                                width: "20px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "start",
                                alignItems: "center",
                                background: "#1EAE60",
                                color: "white",
                              }}
                            >
                              <span>D</span>
                              <span>N</span>
                              <br />
                              <span>T</span>
                              <span>O</span>
                              <span>P</span>
                            </div>
                          </div>
                          {/* LEGENDA */}
                          <div
                            style={{
                              display: "grid",
                              gridTemplateRows: " repeat(6, 1fr)",
                              border: "1px solid #ccc",
                            }}
                          >
                            <div
                              style={{
                                height: "60px",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              Total PDVs
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: dataTable[1][0].color,
                                color: "white",
                              }}
                            >
                              HHB
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: dataTable[6][0].color,
                                color: "white",
                              }}
                            >
                              HB
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: dataTable[11][0].color,
                                color: "white",
                              }}
                            >
                              MB
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: dataTable[16][0].color,
                                color: "white",
                              }}
                            >
                              LB
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: dataTable[21][0].color,
                                color: "white",
                              }}
                            >
                              VLB
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div
                        style={{
                          height: "40px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                        }}
                      >
                        Total Geral
                      </div>
                      <div
                        style={{
                          height: "60px",
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                        }}
                      >
                        <span style={{ fontSize: "12px", fontWeight: "700" }}>
                          {dataTable[1][5].value}
                        </span>
                      </div>
                      {dataTable.map((element, index) => {
                        return (
                          index > 0 &&
                          index < 6 &&
                          dataTable[index].map((element, index) => {
                            let rgb =
                              element.color &&
                              element.color.replace("RGB", "rgb");
                            return (
                              (index == 4 || index == 8 || index == 15) && (
                                <div
                                  style={
                                    index == 4
                                      ? {
                                          height: "20px",
                                          alignItems: "center",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "space-around",
                                          border: "1px solid #ccc",
                                          borderBottom: "none",
                                          borderLeft: "none",
                                          borderRight: "none",
                                        }
                                      : {
                                          height: "20px",
                                          alignItems: "center",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "space-around",
                                        }
                                  }
                                >
                                  {index == 4 && (
                                    <div>
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {element.value}
                                      </span>
                                    </div>
                                  )}
                                  {index == 8 && (
                                    <div>
                                      <span
                                        style={{
                                          fontSize: "8px",
                                          fontWeight: "700",
                                        }}
                                      >
                                        % PDV{element.value}
                                      </span>
                                    </div>
                                  )}
                                  {index == 15 && (
                                    <div>
                                      <span
                                        style={{
                                          fontSize: "8px",
                                          fontWeight: "700",
                                        }}
                                      >
                                        % R$ {element.value}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              )
                            );
                          })
                        );
                      })}
                    </div>
                    <div>
                      <div
                        style={{
                          height: "40px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                          background: dataTable[1][0].color,
                          color: "white",
                        }}
                      >
                        HHB
                      </div>
                      <div
                        style={{
                          height: "60px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                            }}
                          >
                            {dataTable[1][3].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % PDV{dataTable[1][7].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % R$ {dataTable[1][14].value}
                          </span>
                        </div>
                      </div>
                      {dataTable.map((element, index) => {
                        return (
                          index > 0 &&
                          index < 6 &&
                          dataTable[index].map((element, index) => {
                            let rgb =
                              element.color &&
                              element.color.replace("RGB", "rgb");
                            return (
                              index == 2 && (
                                <div
                                  style={{
                                    background: element.color
                                      ? element.color.replace("RGB", "rgb")
                                      : "",
                                    height: "60px",
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderTop: "none",
                                  }}
                                  key={index}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {element.value}
                                  </span>
                                </div>
                              )
                            );
                          })
                        );
                      })}
                    </div>
                    <div>
                      <div
                        style={{
                          height: "40px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                          background: dataTable[6][0].color,
                          color: "white",
                        }}
                      >
                        HB
                      </div>
                      <div
                        style={{
                          height: "60px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                        }}
                      >
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                            }}
                          >
                            {dataTable[6][3].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % PDV{dataTable[6][7].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % R$ {dataTable[6][14].value}
                          </span>
                        </div>
                      </div>
                      {dataTable.map((element, index) => {
                        return (
                          index > 5 &&
                          index < 11 &&
                          dataTable[index].map((element, index) => {
                            let rgb =
                              element.color &&
                              element.color.replace("RGB", "rgb");
                            return (
                              index == 2 && (
                                <div
                                  style={{
                                    background: element.color
                                      ? element.color.replace("RGB", "rgb")
                                      : "",
                                    height: "60px",
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderTop: "none",
                                    borderLeft: "none",
                                  }}
                                  key={index}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {element.value}
                                  </span>
                                </div>
                              )
                            );
                          })
                        );
                      })}
                    </div>
                    <div>
                      <div
                        style={{
                          height: "40px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                          background: dataTable[11][0].color,
                          color: "white",
                        }}
                      >
                        MB
                      </div>
                      <div
                        style={{
                          height: "60px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                        }}
                      >
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                            }}
                          >
                            {dataTable[11][3].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % PDV{dataTable[11][7].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % R$ {dataTable[11][14].value}
                          </span>
                        </div>
                      </div>
                      {dataTable.map((element, index) => {
                        return (
                          index > 10 &&
                          index < 16 &&
                          dataTable[index].map((element, index) => {
                            let rgb =
                              element.color &&
                              element.color.replace("RGB", "rgb");
                            return (
                              index == 2 && (
                                <div
                                  style={{
                                    background: element.color
                                      ? element.color.replace("RGB", "rgb")
                                      : "",
                                    height: "60px",
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderTop: "none",
                                    borderLeft: "none",
                                  }}
                                  key={index}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {element.value}
                                  </span>
                                </div>
                              )
                            );
                          })
                        );
                      })}
                    </div>
                    <div>
                      <div
                        style={{
                          height: "40px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                          background: dataTable[16][0].color,
                          color: "white",
                        }}
                      >
                        LB
                      </div>
                      <div
                        style={{
                          height: "60px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                        }}
                      >
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                            }}
                          >
                            {dataTable[16][3].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % PDV{dataTable[16][7].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % R$ {dataTable[16][14].value}
                          </span>
                        </div>
                      </div>
                      {dataTable.map((element, index) => {
                        return (
                          index > 15 &&
                          index < 21 &&
                          dataTable[index].map((element, index) => {
                            let rgb =
                              element.color &&
                              element.color.replace("RGB", "rgb");
                            return (
                              index == 2 && (
                                <div
                                  style={{
                                    background: element.color
                                      ? element.color.replace("RGB", "rgb")
                                      : "",
                                    height: "60px",
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderTop: "none",
                                    borderLeft: "none",
                                  }}
                                  key={index}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {element.value}
                                  </span>
                                </div>
                              )
                            );
                          })
                        );
                      })}
                    </div>
                    <div>
                      <div
                        style={{
                          height: "40px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                          background: dataTable[21][0].color,
                          color: "white",
                        }}
                      >
                        VLB
                      </div>
                      <div
                        style={{
                          height: "60px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                            }}
                          >
                            {dataTable[21][3].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % PDV{dataTable[21][7].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % R$ {dataTable[21][14].value}
                          </span>
                        </div>
                      </div>
                      {dataTable.map((element, index) => {
                        return (
                          index > 20 &&
                          index < 26 &&
                          dataTable[index].map((element, index) => {
                            let rgb =
                              element.color &&
                              element.color.replace("RGB", "rgb");
                            return (
                              index == 2 && (
                                <div
                                  style={{
                                    background: element.color
                                      ? element.color.replace("RGB", "rgb")
                                      : "",
                                    height: "60px",
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderTop: "none",
                                    borderLeft: "none",
                                  }}
                                  key={index}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {element.value}
                                  </span>
                                </div>
                              )
                            );
                          })
                        );
                      })}
                    </div>
                    <div>
                      <div
                        style={{
                          height: "40px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                          borderBottom: "none",
                        }}
                      >
                        {" "}
                        Sem Compras
                      </div>
                      <div
                        style={{
                          height: "60px",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          border: "1px solid #ccc",
                        }}
                      >
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "700",
                            }}
                          >
                            {dataTable[26][3].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % PDV{dataTable[26][7].value}
                          </span>
                        </div>
                        <div>
                          {" "}
                          <span
                            style={{
                              fontSize: "8px",
                              fontWeight: "700",
                            }}
                          >
                            % R$ {dataTable[26][14].value}
                          </span>
                        </div>
                      </div>
                      {dataTable.map((element, index) => {
                        return (
                          index > 25 &&
                          index < 31 &&
                          dataTable[index].map((element, index) => {
                            let rgb =
                              element.color &&
                              element.color.replace("RGB", "rgb");
                            return (
                              index == 2 && (
                                <div
                                  style={{
                                    background: element.color
                                      ? element.color.replace("RGB", "rgb")
                                      : "",
                                    height: "60px",
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    border: "1px solid #ccc",
                                    borderTop: "none",
                                    borderLeft: "none",
                                  }}
                                  key={index}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "700",
                                    }}
                                  >
                                    {element.value}
                                  </span>
                                </div>
                              )
                            );
                          })
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                // <table border="1">
                //   <thead>
                //     <tr>
                //       <th></th>
                //       <th>HBB</th>
                //       <th>HB</th>
                //       <th>MB</th>
                //       <th>VLB</th>
                //     </tr>
                //   </thead>
                //   <tbody>
                //     {dataTable.map((element, index) => {
                //       return (
                //         <tr>
                //           {index > 0 &&
                //             index < 5 &&
                //             dataTable[index].map((element, index) => {
                //               return index == 1 && element.value;
                //             })}

                //           {index > 0 &&
                //             index < 10 &&
                //             dataTable[index].map((element, index) => {
                //             let rgb =
                //               element.color &&
                //               element.color.replace("RGB", "rgb");
                //             return (
                //               index == 2 && (
                //                 <td
                //                   style={{
                //                     background: element.color
                //                       ? element.color.replace("RGB", "rgb")
                //                       : "",
                //                   }}
                //                   key={index}
                //                 >
                //                   {element.value}
                //                 </td>
                //               )
                //             );
                //           })}

                //         </tr>
                //       );
                //     })}
                //   </tbody>
                // </table>
                <></>
              )}
            </Card>
            <Card
              header={{
                hardTitle: container[1].cards[1].title.hardTitle,
                hardSubtitle: container[1].cards[1].subtitle.hard,
                tooltip: container[1].cards[1].title.tooltip,
                legends: [
                  {
                    name: container[1].cards[1].legends[0].name,
                    color: container[1].cards[1].legends[0].color,
                  },
                  {
                    type: "bar",
                    name: container[1].cards[1].legends[1].name,
                    color: container[1].cards[1].legends[1].color,
                  },
                ],
              }}
              style={{ width: "35%", height: "100%" }}
            >
              {/* <NativeObject
                app={app}
                key={"indexgs"}
                reference={{ id: "LJVtcq" }}
                // reference={{ id: "LJVtcq" }}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  height: "90%",
                }}
                className="analisePDVs"
                type="table"
              /> */}
              <div style={{ height: "100%", display: "flex", flexDirection:"column", justifyContent: "center" }}>
                <NativeObject
                  app={app}
                  key={container[1].cards[1].nativeObject.valueId}
                  reference={{ id: container[1].cards[1].nativeObject.id }}
                  style={{ height: "100%" }}
                />
              </div>

              {/* <NativeObject
                app={app}
                key={"indexgs"}
                reference={{ id: "13208c27-bf55-4b3e-a94f-bdbafc963025" }}
                // reference={{ id: "LJVtcq" }}
                style={{
                  marginTop: "10px",
                  width: "100%",
                  height: "90%",
                }}
                className="analisePDVs"
                type="table"
              /> */}
            </Card>
          </CardWrapper>

          {/* <CardWrapper customStyle={{ height: "40%" }}>
            <Card
              header={{
                hardTitle: container[2].cards[0].title.hardTitle,
                tooltip: container[2].cards[0].title.tooltip,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[2].cards[0].nativeObject.valueId}
                reference={{ id: container[2].cards[0].nativeObject.id }}
              />
            </Card>
            <Card
              header={{
                hardTitle: container[2].cards[1].title.hardTitle,
                tooltip: container[2].cards[1].title.tooltip,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                key={container[2].cards[1].nativeObject.valueId}
                reference={{ id: container[2].cards[1].nativeObject.id }}
              />
            </Card>
          </CardWrapper> */}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

MatrizDesktop.defaultProps = {
  app: null,
  config: {},
};

MatrizDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default MatrizDesktop;
